import {Component} from 'solid-js';

export interface cmsProps {
    id: string;
    children: any;
}

export const CMS : Component<cmsProps> = (props) =>
<>
    {props.children}
</>